import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import data from "@/data/projects/projects.json";
import PageSEO from "@/components/common/PageSEO";
import Loading from "@/components/common/Loading";
import ProjectsHorizontal from "@/components/portfoliu/projects-horizontal/ProjectsHorizontal";
import Filters from "@/components/portfoliu/filters/Filters";
import Intro from "@/components/service/components/intro/Intro";
import SMMCard from "@/components/SMMcard";
// import { ProjectData } from "@/pages/Project";

// type ProjectPreview = Pick<
//   ProjectData,
//   "id" | "title" | "imgUrl" | "details" | "list" | "date" | "tags" | "type"
// >;

const SMMcontent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    setLoading(false);
  }, []);

  // Filter SMM projects
  const smmProjects = data.filter(project => project.type === "SMM-Content");

  // Portfolio intro data
  const portfolioIntroData = {
    tag: "Portfoliu",
    title: "Portfoliu",
    text: "Conținut SMM de calitate",
    description: "Descoperă proiectele noastre de social media marketing și vezi cum creăm conținut engaging pentru branduri."
  };

  if (loading) return <Loading />;

  return (
    <>
      <PageSEO section="portfolio" keyName="smm-content" />
      <Intro data={portfolioIntroData} />
      <Container style={{ marginTop: "-40px", textAlign: "center" }}>
        <div style={{ 
          display: "inline-block", 
          fontSize: "0.7em",
          transform: "scale(0.85)"
        }}>
          <Filters projects={data} setProjects={() => {}} />
        </div>
      </Container>
      
      {/* SMM Projects Section - ABOVE the cards */}
      <Container style={{ height: "100%" }}>
        <ProjectsHorizontal projects={smmProjects} />
      </Container>

      {/* SMM Content Section */}
      <Container>
        <div className="home">
          <div className="container">
            <h1 className="text-center mb-5">Postări Social Media</h1>
            <div className="smm-grid">
              <SMMCard type="image" src="/smm/smm001.webp" client="Pixado" label="Imagine promoțională "/>
               <SMMCard type="image" src="/smm/smm002.webp" client="Vessa Hospital" label="Imagine promoțională" />
               <SMMCard type="video" src="/smm/smm003.webm" poster="/smm/smm003-thumb.webp" client="Pixado" label="Short Video promoțional"/>
               <SMMCard type="image" src="/smm/smm004.webp" client="Pixado" label="Imagine promoțională "/>
               <SMMCard type="image" src="/smm/smm005.webp" client="Vessa Hospital" label="Imagine promoțională" />
               <SMMCard type="video" src="/smm/smm006.webm" poster="/smm/smm006-thumb.webp" client="Pixado" label="Short Video promoțional"/>
               <SMMCard type="video" src="/smm/smm007.webm" poster="/smm/smm007-thumb.webp" client="Pixado" label="Short Video promoțional"/>
               <SMMCard type="video" src="/smm/smm008V.webm" poster="/smm/smm008-thumb.webp" client="Pixado" label="Short Video promoțional"/>
               <SMMCard type="video" src="/smm/smm009.webm" poster="/smm/smm009-thumb.webp" client="Pixado" label="Short Video promoțional"/>
               <SMMCard type="video" src="/smm/smm010V.webm" poster="/smm/smm010-thumb.webp" client="Pixado" label="Short Video promoțional"/>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default SMMcontent;